import { RootState } from "../../store/types";
import { AppDispatch } from "../../store";
import { connect } from "react-redux";
import VolumesAndWip from "./index";
import { getTargetAndWipVolumeThunk } from "../../store/slices/volumesAndWipSlice";
import { fetchDryRunShiftPlan, generatePlanThunk } from "../../store/slices/checkoutSlice";
import { resetShiftPlanOutput } from "../../store/slices/reviewAndPublishSlice";
import { GetTargetAndWIPVolumeRequest } from "./model";
import { RCC_SHIFT_PLAN_VOLUMES_AND_WIP_TAB } from "../../utils/metric-utils";

const mapStateToProps = (state: RootState) => ({
    targetAndWIPVolume: state.volumesAndWip.targetAndWIPVolume,
    planId: state.shiftPlan.planId,
    date: state.shiftPlan.selectedDate,
    shiftType: state.shiftPlan.selectedShift,
    stationCode: state.shiftPlan.stationCode,
    isCheckoutEnabled: state.checkout.isCheckoutEnabled ?? false,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    getTargetAndWipVolume: (getTargetAndWipVolumeRequest: GetTargetAndWIPVolumeRequest) =>
        dispatch(getTargetAndWipVolumeThunk(getTargetAndWipVolumeRequest)),
    verifyVolumes: async () => 
        await dispatch(fetchDryRunShiftPlan()),
    generatePlan: async (planId: string) =>
        await dispatch(generatePlanThunk({ planId, pageId: RCC_SHIFT_PLAN_VOLUMES_AND_WIP_TAB })),
    resetShiftPlanOutput: () => dispatch(resetShiftPlanOutput())
});

export default connect(mapStateToProps, mapDispatchToProps)(VolumesAndWip);
